import Cookies from 'universal-cookie';

const FLIPPER_VERSION = 'v1';
export const CONTROL_FALLBACK = { variant_name: 'control' };
const EXPERIMENTS_API_HOST = process.env.REACT_APP_GLM_EXPERIMENTS_API_HOST;
const EXPERIMENTS_API_KEY = process.env.REACT_APP_GLM_EXPERIMENTS_API_KEY;

export default class ExperimentsApi {
  static cookies = new Cookies();

  static getSessionToken() {
    if (!ExperimentsApi.cookies) {
      ExperimentsApi.cookies = new Cookies();
    }
    return ExperimentsApi.cookies.get('xo-session-token');
  }

  static baseHeaders() {
    return {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'MEMBERSHIP-SESSION-TOKEN': this.getSessionToken(),
      'x-api-key': EXPERIMENTS_API_KEY,
      'Accept-Version': FLIPPER_VERSION,
    };
  }

  static baseFetch(path, request) {
    return fetch(`${EXPERIMENTS_API_HOST}/${path}`, request)
      .then(ExperimentsApi.parseResponse)
      .catch(error => {
        return Promise.reject(error);
      });
  }

  static parseResponse(response) {
    if (response && response.ok) {
      if (response.status === 200) {
        return response.json();
      } else {
        return Promise.resolve(CONTROL_FALLBACK);
      }
    }

    try {
      return new Promise((_, reject) => {
        response.text().then(text => (text ? reject(JSON.parse(text)) : {}));
      });
    } catch (err) {
      return Promise.reject();
    }
  }

  static get(path) {
    return ExperimentsApi.baseFetch(path, {
      method: 'GET',
      headers: ExperimentsApi.baseHeaders(),
    });
  }

  static getFlipperAssignmentForExperiment = async (experimentId, memberId) => {
    // default to return value 'control' as fallback

    if (!memberId || !experimentId) return CONTROL_FALLBACK;

    return this.get(`experiments/${experimentId}/${memberId}`);
  };
}
